import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Button, Grid, Dropdown, Input } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import $ from "jquery";
import Server from '../../../functions/server';
import Checkbox from '@material-ui/core/Checkbox';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class MaxWidthDialog extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'lg',
    maxWidth1: 'sm',
    datas: [],
    menuOption: [],
    menusOption: [],
    checkBox: [],
    status: 'Normal & Waiting',
    sort: 'asc'
  };

  textboxvalue = (type) => (f, { value }) => {
    this.setState({ [type]: value })
  }

  handleClose = () => {
    this.setState({ open: false });
  };

  checkBoxChange = (type) => (f, { value }) => {
    this.setState({ [type]: value })
  }

  setMenus() {
    let context = this;
    var x = [];
    let menu = ['Long Waiting', 'Waiting', 'Received', 'Custom Received'];
    menu.map((y) => {
      x.push({key: y, text: y, value: y});
    });
    try {
      context.setState({
        menuOption: x,
      });
    } catch (e) {}
  }

  setMenu() {
    let context = this;
    var x = [];
    let menu = ['Long Waiting', 'Waiting', 'Received'];
    menu.map((y) => {
      x.push({key: y, text: y, value: y});
    });
    try {
      context.setState({
        menusOption: x,
      });
    } catch (e) {}
  }


  getPendingStocks() {
    let context = this;
    this.setState({
      load: true,
      edit: false,
      message: 'Getting Purchase Details!!!!',
    });
    $.ajax({
      type: 'POST',
      url: Server() + 'purchaserequest/getallpurchaserequest.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false
        });
        try {
          data = JSON.parse(data);
          console.log(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
          }
          context.setState({
            datas: data,
            data1: data,
            open: true,
          });
        } catch (e) {
          console.log(e);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
    this.setMenus();
    this.setMenu();
  }

  remove(id) {
    let checkBox = this.state.checkBox;
    let removed = [];
    checkBox.map((z) =>{
      if (z.id != id) {
        removed.push({id: z.id});
      }
    })
    this.setState({
      checkBox: removed
    });
  }

  add(id) {
    let checkBox = this.state.checkBox;
    checkBox.push({id: id});
    this.setState({
      checkBox: checkBox
    });
  }

  handleChangeCheckBox = (name) => event => {
    this.checkBox(name);
  };

  checkBox(id) {
    let checkBox = this.state.checkBox;
    if (checkBox.length > 0) {
      for (var i = 0; i < checkBox.length; i++) {
        if (checkBox[i].id == id) {
          this.remove(id);
          return;
        }
      }
      this.add(id);
      return;
    }
    else {
      checkBox.push({id: id});
      this.setState({
        checkBox: checkBox
      });
      return;
    }
  }

  changeStatus() {
    if (!this.props.menuPermission.edit) {
      alert('You Are Not Allow To Edit!!!');
      return;
    }
    let checkBox = this.state.checkBox;
    if (checkBox.length > 0) {
      this.setState({ openStatus: true })
    }
    else {
      alert('Please selected check box');
    }
  }

  sendChangeStatus() {
    let context = this;
    let datas = this.state.datas;
    let checkBox = this.state.checkBox;
    console.log(checkBox);
    console.log(datas);
    for (var i = 0; i < checkBox.length; i++) {
      checkBox[i].status = this.state.changeStatus;
    }

    let items = JSON.stringify(checkBox);
    let data1 = { 'items': items };
    context.setState({
      load: true,
      message: 'Updating Status!!!',
    });
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaserequest/changestatus.php',
      success: function(data)
      {
        console.log(data);
        context.setState({ load: false })
        if (data == 1) {
          checkBox.map((x) => {
            datas.map((c) => {
              if (x.id == c.id) {
                c.status = x.status;
              }
            })
          })
          context.setState({ openStatus: false, datas: datas, data1: datas });
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        })
      }
    })
  }

  save() {
    let context = this;
    let id = this.state.editId;
    let status = this.state.editStatus;
    let datas = this.state.datas;
    this.setState({
      load: true,
      message: 'Editing Status!!!!',
    });
    let data1 = { 'id': id, 'status': status };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaserequest/editstatus.php',
      success: function(data)
      {
        context.setState({ load: false })
        if (data == 1) {
          context.getPendingStocks();
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  onChange = (type) => (f, { value }) => {
    if (value == 'Custom Received') {
      this.setState({ custom: true })
    }
    else {
      this.setState({ editStatus: value })
    }
  }

  handleChanges = name => event => {
    if (!this.props.menuPermission.edit) {
      alert('You Are Not Allow To Edit!!!');
      return;
    }
    let context = this;
    let date = event.target.value;
    let data1 = { 'date': date, 'id': name };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaserequest/changeexepecteddate.php',
      success: function(data)
      {
        if (data == 1) {
          let datas = context.state.datas;
          datas.map((x) => {
            if (x.id == name) {
              x.expected_delivary_date = date+ " 00:00:00";
            }
          });
          context.setState({ datas: datas, data1: datas })
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        })
      }
    })
  };

  received() {
    let context = this;
    let stocks = this.state.received;
    let editId = this.state.editId;
    let datas = this.state.datas;
    let purchase_id, partno, brand_id, totalstocks;
    for (var i = 0; i < datas.length; i++) {
      if (datas[i].id == editId) {
        purchase_id = datas[i].purchase_id;
        partno = datas[i].partno;
        brand_id = datas[i].brand_id;
        totalstocks = datas[i].stock;
      }
    }
    let data1 = { 'purchase_id': purchase_id, 'partno': partno, 'brand_id': brand_id,
                  'stock': stocks, 'id': editId }
    context.setState({ load: true, message: 'Inserting Data' });
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaserequest/insertcustomdata.php',
      success: function(data)
      {
        context.setState({ load: false })
        if (data == 1) {
          datas.map((z) => {
            if (z.id == editId) {
              z.stock = totalstocks - stocks;
            }
          })
          context.setState({ custom: false, edit: false, datas: datas, data1: datas });
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  handleChange = (type) => (f, { value }) => {
    this.setState({ [type]: value })
  }

  sort(val) {
    let data = this.state.datas;
    if (this.state.sort == 'desc') {
      data.sort(this.getSortOrderDesc(val));
      this.setState({
        datas: data,
        sort: 'asc'
      })
    }
    else {
      data.sort(this.getSortOrderAsc(val));
      this.setState({
        datas: data,
        sort: 'desc'
      })
    }
  }

  getSortOrderAsc(prop) {
    return function(a, b) {
      if (a[prop] > b[prop]) {
          return 1;
      } else if (a[prop] < b[prop]) {
          return -1;
      }
      return 0;
    }
  }

  getSortOrderDesc(prop) {
    return function(b, a) {
      if (a[prop] > b[prop]) {
          return 1;
      } else if (a[prop ] < b[prop]) {
          return -1;
      }
      return 0;
    }
  }

  export() {
    if (!this.props.menuPermission.exports) {
      alert('You Are Not Allow To Exports!!!');
      return;
    }
    let search = this.state.search;
    let status = this.state.status.split(' & ')[1];
    let type = this.state.status.split(' & ')[0];
    window.location = Server() + 'purchaserequest/export.php?search='+search+'&status='+status+'&type='+type;
  }

  render() {
    const { classes } = this.props;
    let typeOption = [
      { key: 'Normal & Waiting', text: 'Normal & Waiting', value: 'Normal & Waiting' },
      { key: 'Normal & Long Waiting', text: 'Normal & Long Waiting', value: 'Normal & Long Waiting' },
      { key: 'Urgent & Waiting', text: 'Urgent & Waiting', value: 'Urgent & Waiting' },
      { key: 'Urgent & Long Waiting', text: 'Urgent & Long Waiting', value: 'Urgent & Long Waiting' },
    ]
    let i = 0;
    return (
      <div>
        <React.Fragment>
          <Button primary onClick={this.getPendingStocks.bind(this)}>
            Show Pending Stocks
          </Button>
          <Dialog fullWidth={this.state.fullWidth}  maxWidth={this.state.maxWidth}  open={this.state.open}
            onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={3}>
                  Pending Stocks
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={4}>
                  <Input fluid placeholder='Search Spare Name...' style={{height: 12, fontSize: 18}} onChange={this.handleChange('search')} value={this.state.search} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={4}>
                  <Dropdown id="Control" onChange={this.handleChange('status')}
                    search selection options={typeOption}
                    value={this.state.status} fluid style={{ borderColor: '#5A9CBB', fontSize: 12 }} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={2}>
                  <Button onClick={this.export.bind(this)}>Export</Button>
                </Grid.Column>
              </Grid>
            </DialogTitle>
            <DialogContent>
                <table width="100%" id='table'>
                  <tr>
                    <th id='tableheader'><center></center>Sino</th>
                    <th id='tableheader'><center></center>Id</th>
                    <th id='tableheader'><center></center>Part Name</th>
                    <th id='tableheader'><center></center>Brand Name</th>
                    <th id='tableheader'><center></center>Stocks</th>
                    <th id='tableheader' onClick={this.sort.bind(this, 'expected_delivary_date')} style={{width: '17%'}}><center></center>Deli.. Date</th>
                    <th id='tableheader' style={{width: '11%'}}><center></center>Status</th>
                    <th id='tableheader' style={{width: '11%'}}><center></center>Type</th>
                    <th id='tableheader' style={{display: this.props.viewEdits}}><center></center>Edit</th>
                    <th id='tableheader' style={{display: this.props.viewEdits}}><center></center>Changes</th>
                  </tr>
                  { this.state.datas.map((z) => {
                      i++;
                      let date = z.expected_delivary_date;
                      date = date.split(' ')[0];
                      let tags = (
                        <tr>
                          <td><center>{i}</center></td>
                          <td><center>{z.id}</center></td>
                          <td><center>{z.partname}</center></td>
                          <td><center>{z.brandname}</center></td>
                          <td><center>{z.stock}</center></td>
                          <td>
                            <center>
                              <input type="date"
                              onChange={this.handleChanges(z.id)} value={date} />
                            </center>
                          </td>
                          <td><center>{z.status}</center></td>
                          <td><center>{z.type}</center></td>
                          <td style={{cursor: 'pointer', display: this.props.viewEdits}}
                            onClick={ () => { 
                              if (!this.props.menuPermission.edit) {
                                alert('You Are Not Allow To Edit!!!');
                                return;
                              }
                              this.setState({ edit: true, editId: z.id, editStatus: z.status }) 
                            }}>
                            <center>Edit</center>
                          </td>
                          <td style={{width: '8%', display: this.props.viewEdits}}>
                            <center>
                            <Checkbox id={z.id} onChange={this.handleChangeCheckBox(z.id)} color="primary" />
                            </center>
                          </td>
                        </tr>
                      );
                      {
                        let status = this.state.status.split(' & ')[1];
                        let type = this.state.status.split(' & ')[0];
                        if (this.state.search) {
                          let search = this.state.search;
                          let spare = z.partname;
                          let name = false;
                          try {
                            spare = spare.toUpperCase();
                            search = search.toUpperCase();
                            name = spare.includes(search);
                          } catch (e) {

                          }
                          if (name == true) {
                            if (status) {
                              if (status == z.status) {
                                return(
                                  <tbody>
                                    {tags}
                                  </tbody>
                                )
                              }
                            }
                            if (type) {
                              if (type == z.type) {
                                return(
                                  <tbody>
                                    {tags}
                                  </tbody>
                                )
                              }
                            }
                            else {
                              return(
                                <tbody>
                                  {tags}
                                </tbody>
                              )
                            }
                          }
                        }
                        else {
                          if (status) {
                            if (status == z.status) {
                              return(
                                <tbody>
                                  {tags}
                                </tbody>
                              )
                            }
                          }
                          else {
                            return(
                              <tbody>
                                {tags}
                              </tbody>
                            )
                          }
                          if (type) {
                            if (type == z.type) {
                              return(
                                <tbody>
                                  {tags}
                                </tbody>
                              )
                            }
                          }
                          else {
                            return(
                              <tbody>
                                {tags}
                              </tbody>
                            )
                          }
                        }
                      }
                    })
                  }
                </table>
            </DialogContent>
            <DialogActions>
              <Button primary onClick={this.changeStatus.bind(this)}>Change Status</Button>
              <Button onClick={this.handleClose} color="primary">Close</Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>

        <Dialog fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth1}  open={this.state.openStatus}
          aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Request Orders</DialogTitle>
          <DialogContent>
            <DialogContentText>
                <Grid>
                  <Grid.Column mobile={16} tablet={16} computer={16} style={{paddingBottom: '5%'}}>
                    <Dropdown fluid id="Menu" onChange={this.checkBoxChange('changeStatus')}
                      search selection options={this.state.menusOption} value={this.state.changeStatus}
                      style={{ borderColor: '#5A9CBB' }} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <Button secondary fluid onClick={ () => { this.setState({openStatus: false}) } }>Cancel</Button>
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <Button primary fluid onClick={this.sendChangeStatus.bind(this)} >Save</Button>
                  </Grid.Column>
                </Grid>
            </DialogContentText>
          </DialogContent>
        </Dialog>

        <Dialog fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth1}  open={this.state.edit}
          aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Request Orders</DialogTitle>
          <DialogContent>
            <DialogContentText>
                <Grid>
                  <Grid.Column mobile={16} tablet={16} computer={16} style={{paddingBottom: '5%'}}>
                    <Dropdown fluid
                      id="Menu" onChange={this.onChange('menu')}
                      search selection options={this.state.menuOption}
                      value={this.state.editStatus} fluid style={{ borderColor: '#5A9CBB' }} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <Button secondary fluid onClick={ () => { this.setState({edit: false}) } }>Cancel</Button>
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <Button primary fluid onClick={this.save.bind(this)}>Save</Button>
                  </Grid.Column>
                </Grid>
            </DialogContentText>
          </DialogContent>
        </Dialog>

        <Dialog fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth1}  open={this.state.custom}
          aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Custom Received Stocks</DialogTitle>
          <DialogContent>
            <DialogContentText>
                <Grid>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <Input fluid focus onChange={this.textboxvalue('received')}
                        value={this.state.received} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <Button secondary fluid onClick={ () => { this.setState({custom: false}) } }>Cancel</Button>
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <Button primary fluid onClick={this.received.bind(this)}>Save</Button>
                  </Grid.Column>
                </Grid>
            </DialogContentText>
          </DialogContent>
        </Dialog>

      </div>
    );
  }
}

MaxWidthDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MaxWidthDialog);
